class CompareUtils {
  static getCookieName() {
    return 'compare-products-global';
  }

  static getSelectedProducts() {
    try {
      const products = sessionStorage.getItem(this.getCookieName());
      return products ? JSON.parse(products) : [];
    } catch (error) {
      console.warn('Error reading compare products from sessionStorage:', error);
      return [];
    }
  }

  static setSelectedProducts(products) {
    try {
      if (products.length > 0) {
        sessionStorage.setItem(this.getCookieName(), JSON.stringify(products));
      } else {
        sessionStorage.removeItem(this.getCookieName());
      }
    } catch (error) {
      console.warn('Error saving compare products to sessionStorage:', error);
    }
  }

  static getProductsCount() {
    return this.getSelectedProducts().length;
  }

  static isProductInList(productId) {
    const products = this.getSelectedProducts();
    return products.some(product => product.id === productId);
  }

  static addToList(productId, productUrl, productTitle, productImage, productPrice) {
    let products = this.getSelectedProducts();
    const maxProducts = 5;
    
    if (products.length >= maxProducts) {
      return false;
    }

    if (!products.some(product => product.id === productId)) {
      products.push({
        id: productId,
        url: productUrl,
        title: productTitle,
        image: productImage,
        price: productPrice
      });
      
      this.setSelectedProducts(products);
      this.updateCompareCheckboxes();
      this.updateCompareBar();
      this.publishEvent('compare:add', { products, productId });
      return true;
    }
    return false;
  }

  static removeFromList(productId) {
    let products = this.getSelectedProducts();
    products = products.filter(product => product.id !== productId);
    
    this.setSelectedProducts(products);
    this.updateCompareCheckboxes();
    this.updateCompareBar();
    this.publishEvent('compare:remove', { products, productId });
  }

  static clearList() {
    this.setSelectedProducts([]);
    this.updateCompareCheckboxes();
    this.updateCompareBar();
    this.publishEvent('compare:clear', { products: [] });
  }

  static updateCompareCheckboxes() {
    const products = this.getSelectedProducts();
    document.querySelectorAll('.js-compare-checkbox').forEach(checkbox => {
      const productId = checkbox.dataset.productId;
      checkbox.checked = products.some(product => product.id === productId);
    });
  }

  static updateCompareBar() {
    const products = this.getSelectedProducts();
    const compareBar = document.querySelector('.compare-bar');
    const counters = document.querySelectorAll('.compare-bar__counter, .compare-drawer-counter, .compare-mobile-counter');
    
    const desktopSlots = document.querySelectorAll('[data-desktop-slot="true"]');
    const drawerSlots = document.querySelectorAll('[data-drawer-slot="true"]');

    counters.forEach(counter => {
      counter.textContent = products.length;
    });

    const compareButtons = document.querySelectorAll('.compare-bar__open, .compare-drawer__open');
    compareButtons.forEach(btn => {
      btn.disabled = products.length < 2;
    });

    desktopSlots.forEach((slot, index) => {
      this.updateSlot(slot, products[index]);
    });

    drawerSlots.forEach((slot, index) => {
      this.updateSlot(slot, products[index]);
    });

    document.querySelectorAll('.slot-remove').forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.removeFromList(newBtn.dataset.productId);
      });
    });
  }

  static updateSlot(slot, product) {
    if (product) {
      slot.className = 'compare-slot filled';
      slot.innerHTML = `
        <div class="slot-product">
          <img src="${product.image}" alt="${product.title}" class="slot-image">
          <button class="slot-remove" data-product-id="${product.id}" aria-label="Çıkar">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      `;
    } else {
      slot.className = 'compare-slot empty';
      slot.innerHTML = '';
    }
  }


  static publishEvent(eventName, data) {
    document.dispatchEvent(new CustomEvent(eventName, { detail: data }));
  }
}

class CompareSwitch extends HTMLElement {
  constructor() {
    super();
    
    this.cookieName = 'compare-is-active-global';
    this.classes = {
      isActive: 'is-product-comparing'
    };
    
    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);
  }

  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
    
    document.addEventListener('compare:sync-switches', (e) => {
      if (e.detail.source !== this.checkboxEl.id) {
        this.checkboxEl.checked = e.detail.isActive;
      }
    });
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    try {
      const isActive = localStorage.getItem(this.cookieName) === 'true';
      this.checkboxEl.checked = isActive;
      this.handleChange(isActive, true);
    } catch (error) {
      console.warn('Error reading compare switch state:', error);
      this.checkboxEl.checked = false;
      this.handleChange(false, true);
    }
  }

  onChange(evt) {
    evt.preventDefault();
    this.handleChange(this.checkboxEl.checked, false);
  }

  handleChange(isActive, isInit = false) {
    requestAnimationFrame(() => {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    });

    if (!isInit) {
      document.dispatchEvent(new CustomEvent('compare:sync-switches', { 
        detail: { 
          isActive, 
          source: this.checkboxEl.id 
        } 
      }));
    }

    CompareUtils.publishEvent('compare:toggle', { isActive });
    
    try {
      localStorage.setItem(this.cookieName, isActive);
    } catch (error) {
      console.warn('Error saving compare switch state:', error);
    }

    this.updateCompareBarVisibility(isActive);
    this.updateMobileDrawerTrigger(isActive);
  }

  updateMobileDrawerTrigger(isActive) {
    const trigger = document.getElementById('compareMobileDrawerTrigger');
    if (trigger) {
      trigger.style.display = isActive ? 'block' : 'none';
    }
  }

  updateCompareBarVisibility(isActive) {
    const compareBar = document.querySelector('.compare-bar');
    if (compareBar) {
      if (isActive) {
        compareBar.classList.add('compare-bar--visible');
        CompareUtils.updateCompareBar();
      } else {
        compareBar.classList.remove('compare-bar--visible');
      }
    }
  }
}


class CompareCheckbox extends HTMLElement {
  constructor() {
    super();
    
    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);
  }

  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    const { productId } = this.checkboxEl.dataset;
    this.checkboxEl.checked = CompareUtils.isProductInList(productId);
  }

  onChange(evt) {
    evt.preventDefault();
    
    const { 
      productId, 
      productUrl, 
      productTitle, 
      productImage, 
      productPrice 
    } = this.checkboxEl.dataset;

    if (this.checkboxEl.checked) {
      const isAdded = CompareUtils.addToList(
        productId, 
        productUrl, 
        productTitle, 
        productImage, 
        productPrice
      );
      
      if (!isAdded) {
        this.checkboxEl.checked = false;
      }
    } else {
      CompareUtils.removeFromList(productId);
    }
  }
}

customElements.define('compare-switch', CompareSwitch);
customElements.define('compare-checkbox', CompareCheckbox);

document.addEventListener('DOMContentLoaded', () => {
  CompareUtils.updateCompareBar();
  
  const mobileTrigger = document.getElementById('compareMobileDrawerTrigger');
  if (mobileTrigger) {
    mobileTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      const drawer = document.getElementById('CompareDrawer');
      if (drawer) {
        drawer.removeAttribute('hidden');
        requestAnimationFrame(() => {
          const overlay = drawer.querySelector('overlay-element');
          const header = drawer.querySelector('.drawer__header');
          const content = drawer.querySelector('.drawer__content');
          
          if (overlay) {
            overlay.classList.remove('invisible', 'opacity-0');
            overlay.classList.add('visible', 'opacity-100');
            overlay.setAttribute('aria-expanded', 'true');
          }
          
          if (header) {
            header.classList.remove('invisible', 'opacity-0');
            header.classList.add('visible', 'opacity-100');
          }
          
          if (content) {
            content.classList.remove('invisible', 'opacity-0');
            content.classList.add('visible', 'opacity-100');
          }
          
          drawer.classList.add('drawer--open');
        });
      }
    });
  }

  document.addEventListener('click', function(e) {
    const drawer = document.getElementById('CompareDrawer');
    if (!drawer) return;
    
    const overlay = drawer.querySelector('overlay-element');
    
    if (e.target === overlay || e.target.closest('.drawer__close')) {
      e.preventDefault();
      closeCompareDrawer();
    }
  });

  const drawerClearButtons = document.querySelectorAll('.compare-drawer__clear');
  drawerClearButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      CompareUtils.clearList();
    });
  });

  function closeCompareDrawer() {
    const drawer = document.getElementById('CompareDrawer');
    if (!drawer) return;
    
    const overlay = drawer.querySelector('overlay-element');
    const header = drawer.querySelector('.drawer__header');
    const content = drawer.querySelector('.drawer__content');
    
    if (overlay) {
      overlay.classList.remove('visible', 'opacity-100');
      overlay.classList.add('invisible', 'opacity-0');
      overlay.setAttribute('aria-expanded', 'false');
    }
    
    if (header) {
      header.classList.remove('visible', 'opacity-100');
      header.classList.add('invisible', 'opacity-0');
    }
    
    if (content) {
      content.classList.remove('visible', 'opacity-100');
      content.classList.add('invisible', 'opacity-0');
    }
    
    drawer.classList.remove('drawer--open');
    
    setTimeout(() => {
      drawer.setAttribute('hidden', '');
    }, 300);
  }
  
  document.addEventListener('compare:toggle', (e) => {
  });
  
  document.addEventListener('compare:add', (e) => {
  });
  
  document.addEventListener('compare:remove', (e) => {
  });
});